/*
no-jquery.js

A set of global functions useful for working without jquery.
Compiled from http://youmightnotneedjquery.com/.  IE8+ compatibility.

*/
//add class
function addClass(el, className){

  if(!el) return;

  if (el.classList){

    el.classList.add(className);

  }
  else {

    el.className += ' ' + className;

  }

};


//remove class
function removeClass(el, className){

  if(!el) return;

  if (el.classList){

    el.classList.remove(className);

  }
  else {

    el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');

  }

};


//toggle class
function toggleClass(el, className){

  if (el.classList) {
    el.classList.toggle(className);
  } else {
      var classes = el.className.split(' ');
      var existingIndex = -1;
      for (var i = classes.length; i--;) {
        if (classes[i] === className)
          existingIndex = i;
      }

      if (existingIndex >= 0)
        classes.splice(existingIndex, 1);
      else
        classes.push(className);

    el.className = classes.join(' ');
  }

};


//has class
function hasClass(el, className){

  if (el.classList)
    return el.classList.contains(className);
  else
    return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);

}


//ready
function ready(fn) {
  if (document.readyState != 'loading'){
    fn();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    document.attachEvent('onreadystatechange', function() {
      if (document.readyState != 'loading')
        fn();
    });
  }
}

//next element (usage: el.nextElementSibling || nextElementSibling(el); )
function nextElementSibling(el) {
  do { el = el.nextSibling; } while ( el && el.nodeType !== 1 );
  return el;
}

// prevSibling can include text nodes. Usage el.previousElementSibling || previousElementSibling(el);
function previousElementSibling(el) {
  do { el = el.previousSibling; } while ( el && el.nodeType !== 1 );
  return el;
}



//get all siblings
function getSiblings(el){
  var siblings = Array.prototype.slice.call(el.parentNode.children);

  for (var i = siblings.length; i--;) {
    if (siblings[i] === el) {
      siblings.splice(i, 1);
      break;
    }
  }

  return siblings;
}

//add listener
function addListener(el, eventName, handler) {

  if(!el) return;

  if (el.addEventListener) {

    el.addEventListener(eventName, handler);

  } else if (el.attachEvent){

    el.attachEvent('on' + eventName, function(){
      handler.call(el);
    });

  } else {

    el["on" + eventName] = handler;

  }
}

function removeListener(el, eventName, handler) {

  if (el.removeEventListener){

    el.removeEventListener(eventName, handler);

  } else {

    el.detachEvent('on' + eventName, handler);

  }
}

//for each
function forEachElement(selector, fn) {
  var elements = document.querySelectorAll(selector);
  for (var i = 0; i < elements.length; i++)
    fn(elements[i], i);
}

//fire an event
function eventFire(el, etype){
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}

//remove
function remove(el){
  el.parentNode.removeChild(el);
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
//end no-jquery.js

var body = document.getElementsByTagName("body")[0];

/*ADD CLASS FOR NON TOUCH DEVICES*/
function isTouchDevice() {
	try {
		document.createEvent("TouchEvent");
		removeClass(body, 'no-touch');
		return true;
	} catch (e) {
		addClass(body, 'no-touch');
		return false;
	}
}

isTouchDevice();

var shopProductsContainer = document.getElementById('shopProducts');

function updateQueryStringParameters(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}


function fetchNextPage(page, max_page, current_req_loop){
  var loadMoreBlock = document.getElementById('pagination');
  var url = window.location.href.replace(/\?$/,'');
  loadMoreBlock && addClass(loadMoreBlock, 'loading');

  // loadNext.blur();
  if(Shopify.queryParams && Shopify.queryParams.sort_by){
		if(~url.indexOf('sort_by')){
			url = url.replace(
				/sort_by=[^\&]+/i,
				'sort_by=' + Shopify.queryParams.sort_by
				);
		}else{
			url += (~url.indexOf('?') ? '&' : '?')
				+ 'sort_by=' + Shopify.queryParams.sort_by
		}
  }

  var targetUrl = updateQueryStringParameters(url, "page", page);
  targetUrl = updateQueryStringParameters(targetUrl, "view", "ajax-page");

  var request = new XMLHttpRequest();
  request.open('GET', targetUrl, true);

  request.onreadystatechange = function() {
    if (this.readyState === 4) {
      if(current_req_loop != window.tracked_loop) return;
      if (this.status >= 200 && this.status < 400) {
        // Success!
        loadMoreBlock && removeClass(loadMoreBlock, 'loading');
        containerHTML = shopProductsContainer.innerHTML;
        shopProductsContainer.insertAdjacentHTML('beforeend', this.responseText);
        if(window.Countdowns) Countdowns('countdown');

        if (page <= max_page) {

          shopProductsContainer.setAttribute("data-page", page + 1);
          updateFilter(current_req_loop);

        } else {

          updateFilter(current_req_loop);
          // addClass(loadNext, 'hidden');

        }

        if(page == max_page){
          // addClass(loadNext, 'hidden');
        }

      } else {
        // Error :(
      }
    }
  };

  request.send();
  request = null;

}

var sortDrop = document.getElementById('sort-drop');

if (sortDrop !== null) {

    //SORTING DROPDOWN
    function updateShopifyQueryParams () {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
              Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    }
    updateShopifyQueryParams();

    var filter_types = ['','finish_','application_','design_'];
    var sortLinks = document.querySelectorAll('.sort-link');
    var sortToggle = document.getElementById('grid__sort-toggle');
    var sortDropdown = document.getElementById('grid__sort-dropdown');
    var sortDropToggle = document.getElementById('grid__sortDrop')
    var pagination = document.getElementById('pagination-links');
    var loadMoreElement = document.createElement('a');

    // Lets add and hide a load more
    loadMoreElement.classList.add('pagination__load-more');
    loadMoreElement.classList.add('button');
    loadMoreElement.innerHTML = 'LOAD MORE';
    loadMoreElement.href = 'javascript:void(0)';
    loadMoreElement.setVisibility = function (show) {
        loadMoreElement.classList[
            show ? 'remove' : 'add'
        ]('pagination__load-more--hidden');
    };
    loadMoreElement.addEventListener('click', function (e) {
        e.preventDefault();
        num_loads++;
        updateFilter();
        updatePushState();
    });
    loadMoreElement.setVisibility(false);
    if(pagination) pagination.parentNode.appendChild(loadMoreElement);

    for (i = 0; i < sortLinks.length; ++i) {

			if (Shopify.queryParams.sort_by == sortLinks[i].getAttribute('data-sort')) {

				var text = sortLinks[i].innerHTML;
				sortToggle.innerHTML = text;

			}

			// Scope the sortlink
			(function (sortLink) {

				addListener(sortLink, 'click', function () {

					Shopify.queryParams.sort_by = this.getAttribute('data-sort');

					var param = Object.keys(Shopify.queryParams).map(function (k) {
							return encodeURIComponent(k) + '=' + encodeURIComponent(Shopify.queryParams[k])
					}).join('&');


					document.getElementById('grid__sort-toggle').innerHTML = sortLink.innerHTML;

					resetFilter();

					sortToggle.click();

				});

			})(sortLinks[i])

    }

    sortDropToggle.addEventListener('click', function (e) {
      if (sortDrop.classList.contains('active')){
        sortDrop.classList.remove('active');
        sortDropToggle.classList.remove('active');
      } else {
        sortDrop.classList.add('active');
        sortDropToggle.classList.add('active');
      }
    });


    //FILTERS // CLIENT SIDE METHOD (AJAXES AND SCRAPES PAGES FOR MATCHES)

    var filterLinks = document.querySelectorAll('.shop-filter-link');
    var finishLinks = document.querySelectorAll('.finish-filter-link');
    var applicationLinks = document.querySelectorAll('.type-filter-link');
    var designLinks = document.querySelectorAll('.color-filter-link');

    var numMatches = 0;
    var num_loads = Shopify.queryParams.pagination || 1;
    var load_one = true;
    var per_page = 36;

    var filters = {
      "finish": [],
      "application": [],
      "design": []
    };

    function updateFilterObject(link, type, data) {
      var emptyFilterStatement = true;

      if (!hasClass(link, 'active')) {
        addClass(link, 'active');

        if (filters[type].indexOf(data) === -1) {
          filters[type].push(data);
        }

        var text = link.innerText || link.textContent;
        var filterTag = '<a class="current-filter-tag" onclick="clickFilter(this, \'' + data + '\')" id="current-filter-tag-' + data + '" href="javascript:void(0)">' + text + ' <span>&times;</span></a>';
        currentFilters.insertAdjacentHTML('afterBegin', filterTag);

      } else {
        removeClass(link, 'active');

        if(document.getElementById('current-filter-tag-' + data)) {
          remove(document.getElementById('current-filter-tag-' + data));
        }

        var currentFilterTags = document.querySelectorAll(".current-filter-tag");
        if (currentFilterTags.length < 1) {
          removeClass(currentFilters, 'active');
        }

        for (var i = filters[type].length - 1; i >= 0; i--) {
          if (filters[type][i] === data) {
            filters[type].splice(i, 1);
            break;
          }
        }
      }

      for (var filter in filters) {
        if( filters.hasOwnProperty( filter ) ) {
          if (filters[filter].length) {
            emptyFilterStatement = false;
            break;
          }
        }
      }

      if (emptyFilterStatement) {
        setTimeout(function() {
          clearAllFilters();
        }, 100);
      }
    }

    function clickFilter(el,data) {
      for (i = 0; i < filterLinks.length; ++i) {
        var linkData = filterLinks[i].getAttribute("data-filter");

        if (data == linkData) {
            filterLinkClick.call(filterLinks[i]);
        }
      }
    }

    for (i = 0; i < filterLinks.length; ++i) {
      addListener(filterLinks[i], 'click', filterLinkClick);
    }

    function filterLinkClick(e,self) {
      self = self ? self : this;
      var data = self.getAttribute("data-filter");
      addClass(currentFilters, 'active');

      if (hasClass(self, 'finish-filter-link')) {
        updateFilterObject(self, "finish", data);
      } else if (hasClass(self, 'application-filter-link')) {
        updateFilterObject(self, "application", data);
      } else if (hasClass(self, 'design-filter-link')) {
        updateFilterObject(self, "design", data);
      } 
      // resetFilter();
    }

    var filterUpdateButton = document.getElementById('update-filter');
    var filterUpdateLink = document.getElementById('update-filter-link');
    var currentFilters = document.getElementById('current-filters');
    var clearFilters = document.querySelectorAll(".clear-filters");
    
    addListener(filterUpdateButton, 'click', function () {
      resetFilter();
    });

    addListener(filterUpdateLink, 'click', function () {
      resetFilter();
    });

    addListener(clearFilters, 'click', clearAllFilters);

    $('#clear-filters').click(function () {
      clearAllFilters('all');
    });

    // $('.clear-filters').click(function () {
    //   var cleartype = $(this).attr('data-filter-type');
    //   clearAllFilters(cleartype);
    // });
    function clearAllFilters () {

      filters = {
          "finish": [],
          "application": [],
          "design": []
      };

      for (i = 0; i < filterLinks.length; ++i) {
          removeClass(filterLinks[i], 'active');
      }

      var currentFilterTags = document.querySelectorAll(".current-filter-tag");

      for (i = 0; i < currentFilterTags.length; ++i) {
          remove(currentFilterTags[i]);
      }

      removeClass(currentFilters, 'active');

      resetFilter();

  }

    // function clearAllFilters (filtertype) {

    //   if(filtertype == 'finish') {
    //     filters['finish'] = [];
    //     for (i = 0; i < finishLinks.length; ++i) {
    //       removeClass(finishLinks[i], 'active');
    //     }
    //     var currentFilterTags = document.querySelectorAll(".current-filter-type-finish");
    //   } else if(filtertype == 'application') {
    //     filters['application'] = [];
    //     for (i = 0; i < applicationLinks.length; ++i) {
    //       removeClass(applicationLinks[i], 'active');
    //     }
    //     var currentFilterTags = document.querySelectorAll(".current-filter-type-application");
    //   } else if(filtertype == 'design') {
    //     filters['design'] = [];
    //     for (i = 0; i < designLinks.length; ++i) {
    //       removeClass(designLinks[i], 'active');
    //     }
    //     var currentFilterTags = document.querySelectorAll(".current-filter-type-design");
    //   } else if(filtertype == 'all') {
    //     filters = {
    //         "finish": [],
    //         "application": [],
    //         "design": []
    //     };
    //     for (i = 0; i < filterLinks.length; ++i) {
    //         removeClass(filterLinks[i], 'active');
    //     }
    //     var currentFilterTags = document.querySelectorAll(".current-filter-tag");
    //       }
    //     for (i = 0; i < currentFilterTags.length; ++i) {
    //         remove(currentFilterTags[i]);
    //     }
    //     removeClass(currentFilters, 'active');
    //     resetFilter();

    // }

    Array.prototype.contains = function (k) {
      for (var i = 0; i < this.length; i++) {
        if (this[i] === k) {
          return true;
        }
      }
        return false;
    }

    function checkFilter(classList, type) {
      if (!filters[type].length > 0) {
          return true;
        }
        for (var j = 0; j < filters[type].length; j++) {
          if (classList.contains(filters[type][j])) {
            return true;
        }
      }
    };

    function resetFilter() {
      // num_loads = 1;
      load_one = getCurrentPaginationNumber() == 1;
      var container = document.querySelector('#shopProducts');
      // Set the query params
      if (!window.no_push) updatePushState();
      container.innerHTML = '';
      var noResultMessage = document.querySelector('.filter-no-results');
      removeClass(noResultMessage, 'active');
      updateFilter();
    }

    function updatePushState () {
      var query_string = [];
      for (var i = 0; i < filter_types.length; i++) {
        var filter_slug = filter_types[i].replace(/_/g,'');
        if(filters[filter_slug] && filters[filter_slug].length) {
          query_string.push(
            filter_types[i] + 'filters='
            + filters[filter_slug].join(',')
          )
        }
      }

      query_string.push('sort_by=' + Shopify.queryParams.sort_by || '');
      query_string.push('pagination=' + num_loads);
      window.history.pushState(
        {
          filters: filters,
          sort_by: Shopify.queryParams.sort_by || '',
          pagination: num_loads
        },"",
        window.location.href.split('?')[0] + '?' + query_string.join('&')
      );
    }

    function filtersCount () {
      return Object.keys(filters).reduce(function (t,k) {
        return t.concat(filters[k]);
      }, []).length;
    }

    function getCurrentPaginationNumber () {
      return Shopify.queryParams.page || "1";
    }

    function updateFilter(current_req_loop, args) {

      if(!args) args = {};

      var products = document.querySelectorAll('.grid__item');
      var container = document.getElementById('shopProducts');
      // var loadNext = document.getElementById('load-next-page');
      var paging = pagination;

      if(!current_req_loop) {
          window.tracked_loop = (Math.random(1,10) * 10000).toFixed();
          current_req_loop = window.tracked_loop;
      }else if(current_req_loop !== window.tracked_loop) {
          return;
      }
      loadMoreElement.setVisibility(false);
      paging && paging.classList[
            filtersCount() ? 'add' : 'remove'
      ]('hidden');

      results = false;
      numMatches = 0;

        for (i = 0; i < products.length; ++i) {
          var classList = products[i].className.split(/\s+/);
          if (checkFilter(classList, "finish") &&
              checkFilter(classList, "application") &&
              checkFilter(classList, "design")) 
            {
            products[i].style.display = "block";
            results = true;
            numMatches++;
          } else {
            products[i].parentNode.removeChild(products[i]);
          }

        }

        var page = parseInt(container.getAttribute("data-page"));
        var current_page = page - 1;
        var max_page = parseInt(container.getAttribute("data-max-page"));
        var desired_matches = per_page * num_loads;
        if (numMatches < desired_matches) {
          if (current_page < max_page || load_one) {
            if (load_one) {
              fetchNextPage(1, max_page, current_req_loop);
              load_one = false;
            } else {
              fetchNextPage(page, max_page, current_req_loop);
            }
          } else if (numMatches == 0) {
            var noResultMessage = document.querySelector('.filter-no-results');
            addClass(noResultMessage, 'active');
            paging && addClass(paging, 'hidden');
            loadMoreElement.setVisibility(false);
            } else {
              paging && addClass(paging, 'hidden');
              loadMoreElement.setVisibility(current_page < max_page);
            }
        } else {
          loadMoreElement.setVisibility(current_page < max_page);
        }
        if(!filtersCount()) loadMoreElement.setVisibility(false);
        var hidingpaginations = document.querySelectorAll(".count-pagination");
        for (i = 0; i < hidingpaginations.length; ++i) {
          if(filtersCount()){
            addClass(hidingpaginations[i], 'hide');
          }else{
            removeClass(hidingpaginations[i], 'hide');
          }
        }
    }

    function handleFilterQueryParams (initial_load) {

      window.no_push = true;

      // remove active links
      $('.shop-filter-link.active').each(function () {
        filterLinkClick(null,this);
      });

      // Loop through and set the active filters
      var has_filters = false;
      for (var i = 0; i < filter_types.length; i++) {
        if(Shopify.queryParams[filter_types[i] + 'filters']) {
          var query_filters = Shopify.queryParams[filter_types[i] + 'filters'].split(',');
          for (var j = 0; j < query_filters.length; j++) {
            var link_el = $('[data-filter="' + query_filters[j] + '"]'),
                filter_type = filter_types[i].replace(/_/gi,'');
            // link_el.addClass('active');
            // filters[filter_type].push(query_filters[j]);
            updateFilterObject(link_el[0], filter_type, query_filters[j]);
          }
          has_filters = true;
        }
      }

      if(!initial_load || has_filters) {
        if(has_filters) {
          addClass(currentFilters, 'active');
          resetFilter();
        } else {
          clearAllFilters();
        }
      }

      window.no_push = false;

    }

    handleFilterQueryParams(true);
    window.onpopstate = function(e){
      // Set the number of loads to request
      num_loads = e.state && e.state.pagination
        ? e.state.pagination : 1 ;
      // update the query params
      updateShopifyQueryParams();
      handleFilterQueryParams();
      // Make sure sort text updates
      var current_sort = $('[data-sort="' + Shopify.queryParams.sort_by + '"]');
      sortToggle.innerHTML = current_sort.length ? current_sort.text() : 'Sort' ;

    };
  }

